module.exports = __webpack_public_path__ + "img/03-illu-sweets0226.e9c60ff8.png";